import {
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { MatDialogModule } from '@angular/material/dialog';
import { SerialSearchComponent } from '../serial-search/serial-search.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InspectorDialogModel } from '../models/inspector-dialog.models';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { QBuiltInspectorConstants } from '../../models/constants/qbuilt-inspector.constants';
import {
  MatCheckboxChange,
  MatCheckboxModule,
} from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';
import { HttpClient } from '@angular/common/http';
import { UrlBuilderService } from 'src/app/shared/services/url-builder.service';
import { TokenClaimsService } from 'src/app/shared/services/token-claims.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HbgSnackBar } from 'src/app/shared/toaster/hbg-toaster';
//potential fix for preview
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'inspector-dialog',
  imports: [
    MatDialogModule,
    SerialSearchComponent,
    DropdownComponent,
    MatCheckboxModule,
    MatIcon,
    MatProgressSpinnerModule,
  ],
  templateUrl: './inspector-dialog.component.html',
  styleUrl: './inspector-dialog.component.scss',
})
export class InspectorDialogComponent implements OnDestroy {
  //dialog types
  // 1 = add new serial
  newSerialDialogTitle: string = this.qbuiltInspConstants.newSerialDialogTitle;
  newSerialInputTitle: string = this.qbuiltInspConstants.newSerialInputTitle;
  // 2 = photo attach
  photoAttachTitle: string = this.qbuiltInspConstants.attachPhotosTitle;
  optionalText: string = this.qbuiltInspConstants.optionalString;
  photoAttachMessage: string = this.qbuiltInspConstants.attachPhotosMessage;
  fileTypeMessage: string = this.qbuiltInspConstants.fileTypeMessage;
  photoLimitMessage: string = this.qbuiltInspConstants.limitMessage;
  photoMaxMessage: string = this.qbuiltInspConstants.maxMessage;
  addNewPhotoText: string = this.qbuiltInspConstants.addNewPhoto;
  uploadPhotoText: string = this.qbuiltInspConstants.uploadPhoto;
  saveBtnText: string = this.qbuiltInspConstants.saveButtonText;
  // 3 = add observed defect
  odDefectTitle: string = this.qbuiltInspConstants.odDialogTitle;
  odDefectMessage: string = this.qbuiltInspConstants.odDialogMessage;
  // 4 = final sign off
  finalSignOffTitle: string = this.qbuiltInspConstants.finalSignOffTitle;
  finalSignOffMessage: string = this.qbuiltInspConstants.finalSignOffMessage;
  finalSignOffPlaceholder: string =
    this.qbuiltInspConstants.finalSignOffPlaceholder;
  //5 = designate to station
  designateTitle: string = this.qbuiltInspConstants.designateTitle;
  selectedStation: any;
  availableStations: any[] = [];

  //button Text
  cancelButtonText: string = this.qbuiltInspConstants.cancelButtonText;
  startButtonText: string = this.qbuiltInspConstants.startmButtonText;
  confirmButtonText: string = this.qbuiltInspConstants.confirmButtonText;
  sendButtonText: string = this.qbuiltInspConstants.sendText;

  dialogType: number;
  inputValue: string = '';
  validSerial: boolean = false;

  observedDefectList: any[] = [];
  selectedDefectTask: any;

  isSignatureGenerated: boolean = false;
  userName: string = '';
  userId: number;
  signature: string = '';
  currentDateTime: string = '';

  //additional Photo upload properties
  saveTrigger: boolean = false;
  photosAttached: boolean = false;
  selectedFile: File | null = null;
  attachedPhotos: any[] = [];
  photoError: boolean = false;
  endPointUrl: string = '';
  photoPreviewErrorMsg: string = this.qbuiltInspConstants.previewErrorMsg;
  photoErrorMsg: string = this.qbuiltInspConstants.photoErrorMsg;

  //session storage keys
  cqmsSessionKey: string = this.qbuiltInspConstants.cqmsItemsKey;
  cqmsDefectItemsKey: string = this.qbuiltInspConstants.defectItemsKey;

  //final photo list to send back from dialog
  finalPhotoList: any[] = [];
  //used to store the url paths of each photo
  photoUrlKeys: any[] = [];

  //photo preview properties
  //previewUrl: string | null = null;
  previewUrl: SafeUrl | null = null;
  previewVisible: boolean = false;
  previewLoading: boolean = false;
  previewError: boolean = false;

  changesMade: boolean = false;

  //photo delete error properties
  deleteVisible: boolean = false;
  deleteError: boolean = false;
  deleteErrorMsg: string = '';

  @ViewChild('targetImage') imgElement!: ElementRef<HTMLImageElement>;

  constructor(
    private qbuiltInspConstants: QBuiltInspectorConstants,
    private http: HttpClient,
    private urlBuilder: UrlBuilderService,
    private tokenClaimService: TokenClaimsService,
    private toaster: HbgSnackBar,
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<InspectorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: InspectorDialogModel,
  ) {
    const userData = localStorage.getItem('userData')
      ? JSON.parse(localStorage.getItem('userData'))
      : null;
    dialogRef.disableClose = true;
    this.dialogType = dialogData.dialogType;
    this.observedDefectList = dialogData.dataList || [];
    this.userName = dialogData.userName || '';
    this.userId = userData?.UserId || 0;
  }

  ngOnInit() {
    //determine if there are photos already attached when modal is opened
    if (this.dialogType === 2) {
      let defect = this.dialogData.dataList || {};
      this.attachedPhotos = defect?.AttachmentLocationKeys || [];
      this.photosAttached = this.attachedPhotos.length > 0;
      if (this.photosAttached) {
        this.finalPhotoList = [...this.attachedPhotos];
      }
    }
  }

  onSerialCheck(response: any) {
    if (response) {
      const cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey)
        ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}')
        : {};
      cqmsSessionItems.selectedSerial = response.serialNumber;
      sessionStorage.setItem(
        this.cqmsSessionKey,
        JSON.stringify(cqmsSessionItems),
      );
      this.inputValue = response;
      this.validSerial = true;
    }
  }

  onDefectSelected(defectTask: string) {
    if (defectTask) {
      this.selectedDefectTask = defectTask;
      //add to defect list or section list or both ?
    }
  }

  generateSignature(event: MatCheckboxChange): void {
    this.isSignatureGenerated = event.checked;

    if (event.checked) {
      this.signature = this.userName;
      this.currentDateTime = new Date().toLocaleString();
    } else {
      this.signature = ''; // Clear signature when unchecked
    }
  }

  onConfirm() {
    if (this.dialogType === 1) {
      this.dialogRef.close(this.inputValue);
      const cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey)
        ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}')
        : {};
      cqmsSessionItems.selectedSerial = '';
      sessionStorage.setItem(
        this.cqmsSessionKey,
        JSON.stringify(cqmsSessionItems),
      );
    } else if (this.dialogType === 3) {
      this.dialogRef.close(this.selectedDefectTask);
    } else if (this.dialogType === 4) {
      this.dialogRef.close(this.userId);
    } else if (this.dialogType === 5) {
      this.dialogRef.close(this.selectedStation);
    }
  }

  /***
   * Used for both Upload from Camera and Upload from Library
   * Supports single (camera) and multiple (library) file selection.
   * Each file is validated before being added to the attached photos list.
   */
  uploadPhoto(event: any) {
    const files: FileList = event.target.files;
    if (!files?.length) return;

    this.photoError = false;

    for (const file of Array.from(files)) {
      if (!this.validatePhoto(file)) {
        this.photoError = true;
        break;
      }

      this.attachedPhotos.push(file);
    }

    this.photosAttached = this.attachedPhotos.length > 0;
    this.selectedFile =
      this.attachedPhotos[this.attachedPhotos.length - 1] ?? null;
    this.changesMade = true;
  }

  //checks if the new photo meets the following requirements
  //file type: jpg, jpeg, png, heic?
  //file size limit: 5 MB
  //under 5 photos
  validatePhoto(file: File): boolean {
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/heic'];
    const maxSize = 5 * 1024 * 1024; // 5 MB

    if (
      !allowedTypes.includes(file.type) ||
      this.attachedPhotos.length >= 5 ||
      file.size > maxSize
    ) {
      console.error(
        'Wrong file type, file type too large or you have reached the photo limit of 5 photos',
      );
      return false;
    } else {
      return true;
    }
  }

  nameValidation(photo: any) {
    if (typeof photo === 'string') {
      return photo.substring(photo.lastIndexOf('/') + 1);
    } else {
      return photo.name;
    }
  }

  //Button on modal to save photos to defect and api
  //will not be saved to DB until user clicks save progress or submits inspection
  async savePhoto() {
    this.saveTrigger = true;

    this.endPointUrl = this.urlBuilder.generateImageUploadUrl();
    const token = this.tokenClaimService.getIdToken();

    if (this.attachedPhotos.length === 0) {
      this.photosAttached = false;
      this.saveTrigger = false;
      this.dialogRef.close(this.finalPhotoList);
      return;
    }

    // Upload photos sequentially, one at a time
    for (const photo of [...this.attachedPhotos]) {
      let photoName;

      //if statement to catch photos that have already been uploaded and were attached prior
      if (!photo.name) continue;

      //if the photo has a name, it is a new photo that needs to be uploaded
      photoName = photo.name;

      try {
        const response = await lastValueFrom(
          this.http.post<any>(`${this.endPointUrl}?docId=${photoName}`, photo, {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': photo.type,
            },
          }),
        );
        this.toaster.open(`Photo Uploaded Successfully`, '✕', {
          duration: 3000,
          panelClass: ['success-toast'],
        });
        this.finalPhotoList.push(response);
      } catch (error) {
        this.saveTrigger = false;
        this.toaster.error(
          `Failed to upload photo(s). Please try again.`,
          '✕',
          {
            duration: 5000,
            panelClass: ['error-toast'],
          },
        );
      }
    }

    // All uploads succeeded — close dialog and pass photos back
    this.saveTrigger = false;
    this.dialogRef.close(this.finalPhotoList);
  }

  //removes photo from list of possible uploads
  removePhoto(photo: any) {
    this.saveTrigger = true;

    //empty photo check
    if (photo.length === 0) {
      this.deleteVisible = true;
      this.deleteError = true;
      this.deleteErrorMsg = `Failed to delete ${photo.substring(photo.lastIndexOf('/') + 1) || 'photo'}. Please try again.`;
      this.saveTrigger = false;
    }

    if (photo instanceof File) {
      // Newly added file — remove from list
      const index = this.attachedPhotos.indexOf(photo);
      if (index > -1) {
        this.attachedPhotos.splice(index, 1);
        //remove the photo from the final photo list if it exists there
        let remove = this.finalPhotoList.filter((p) => p !== photo);
        this.finalPhotoList = remove;
      }
      if (this.attachedPhotos.length === 0) {
        this.photosAttached = false;
        this.selectedFile = null;
      }
      this.saveTrigger = false;
      this.toaster.open(`Photo Deleted Successfully`, '✕', {
        duration: 3000,
        panelClass: ['success-toast'],
      });
    } else if (typeof photo === 'string') {
      // Previously attached S3 key — fetch from API
      const token = this.tokenClaimService.getIdToken();
      const baseUrl = this.urlBuilder.generateImageUploadUrl();
      this.http
        .delete(
          `${baseUrl}?docId=${photo.substring(photo.lastIndexOf('/') + 1)}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        )
        .subscribe({
          next: () => {
            const index = this.attachedPhotos.indexOf(photo);
            if (index > -1) {
              this.attachedPhotos.splice(index, 1);
              //remove the photo from the final photo list if it exists there
              let remove = this.finalPhotoList.filter((p) => p !== photo);
              this.finalPhotoList = remove;
            }
            if (this.attachedPhotos.length === 0) {
              this.photosAttached = false;
              this.selectedFile = null;
            }
            this.saveTrigger = false;
            this.toaster.open(`Photo Deleted Successfully`, '✕', {
              duration: 3000,
              panelClass: ['success-toast'],
            });
          },
          error: () => {
            this.deleteVisible = true;
            this.deleteError = true;
            this.deleteErrorMsg = `Failed to delete ${photo.substring(photo.lastIndexOf('/') + 1) || 'photo'}. Please try again.`;
            this.saveTrigger = false;
          },
        });
    }
    this.changesMade = true;
  }

  //allows user to preview photo before uploading by clicking on photo name
  previewPhoto(photo: any) {
    this.previewLoading = true;
    this.previewError = false;
    this.previewVisible = true;

    if (photo instanceof File) {
      // Newly added file — create local object URL
      const objectUrl = URL.createObjectURL(photo);
      this.previewUrl = this.sanitizer.bypassSecurityTrustUrl(objectUrl);
      this.previewLoading = false;
    } else if (typeof photo === 'string') {
      // Previously attached S3 key — fetch from API
      const token = this.tokenClaimService.getIdToken();
      const baseUrl = this.urlBuilder.generateImageUploadUrl();
      this.http
        .get<string>(
          `${baseUrl}?docId=${photo.substring(photo.lastIndexOf('/') + 1)}`,
          {
            responseType: 'text' as 'json',
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )
        .subscribe({
          next: (base64) => {
            const mimeType = base64.startsWith('/9j/')
              ? 'image/jpeg'
              : 'image/png';
            this.previewUrl = this.sanitizer.bypassSecurityTrustUrl(
              `data:${mimeType};base64,${base64}`,
            );
            this.previewLoading = false;
          },
          error: (error) => {
            console.log('Failed to load photo preview', error);
            this.previewLoading = false;
            this.previewError = true;
          },
        });
    }
  }

  closePreview() {
    if (this.previewUrl) {
      // URL.revokeObjectURL(this.previewUrl);
    }
    this.previewUrl = null;
    this.previewVisible = false;
    this.previewError = false;
  }

  onPreviewImageError() {
    this.previewLoading = false;
    this.previewError = true;
  }

  ngOnDestroy() {}

  onCancel() {
    // Sign-off dialog (type 4) must close with null so the caller's !result guard fires
    // and the completion flow does not proceed on cancel.
    if (this.dialogType === 4) {
      this.dialogRef.close(null);
      return;
    }

    //remove type File from the attached photos list before closing the dialog
    this.attachedPhotos = this.attachedPhotos.filter(
      (photo) => !(photo instanceof File),
    );
    this.finalPhotoList = [...this.attachedPhotos];

    const cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey)
      ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}')
      : {};
    cqmsSessionItems.selectedSerial = '';
    sessionStorage.setItem(
      this.cqmsSessionKey,
      JSON.stringify(cqmsSessionItems),
    );
    this.dialogRef.close(this.finalPhotoList);
  }

  onStationSelected(station: any) {
    this.selectedStation = station;
  }
}
